module.exports = __webpack_public_path__ + "img/img-30.f45a327f.png";